import { EditableFieldData } from "../../store/bulk-edit-store";

export interface ValidationResult {
  isValid: boolean;
  errorMessage: string | null;
}

// Fields that accept time format (e.g., "4:00 AM", "05:00PM", "8:00:00AM") despite being typed as "numeric"
const TIME_FORMAT_FIELDS = ["First Possible EB CPT"];

// Regex: 1-2 digit hour, colon, 2 digit minutes, optional seconds, optional space, AM/PM
const TIME_FORMAT_REGEX = /^\d{1,2}:\d{2}(:\d{2})?\s?(AM|PM|am|pm)$/;

/**
 * Validates a cell value against field-specific rules.
 * Returns { isValid, errorMessage }.
 */
export function validateCell(value: string, fieldName: string, fieldData: EditableFieldData): ValidationResult {
  // 1. Required check
  if (fieldData.required && (!value || value.trim() === "")) {
    return { isValid: false, errorMessage: "This field is required." };
  }

  // If value is empty and not required, it's valid
  if (!value || value.trim() === "") {
    return { isValid: true, errorMessage: null };
  }

  // 2. Type-specific checks
  // Time-only fields: must match time format, reject numbers
  if (TIME_FORMAT_FIELDS.includes(fieldName)) {
    if (!TIME_FORMAT_REGEX.test(value.trim())) {
      return { isValid: false, errorMessage: "Must be a valid time." };
    }
    return { isValid: true, errorMessage: null };
  }

  switch (fieldData.fieldType) {
    case "numeric": {
      const cleaned = value.replace(/,/g, "");
      if (isNaN(Number(cleaned)) || !isFinite(Number(cleaned))) {
        return { isValid: false, errorMessage: "Must be a valid number." };
      }
      break;
    }
    case "dropdown": {
      if (fieldData.options && fieldData.options.length > 0 && !fieldData.options.includes(value)) {
        return { isValid: false, errorMessage: "Value not in allowed options." };
      }
      break;
    }
    case "date": {
      const parsed = new Date(value);
      if (isNaN(parsed.getTime())) {
        return { isValid: false, errorMessage: "Must be a valid date." };
      }
      break;
    }
  }

  return { isValid: true, errorMessage: null };
}
